<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="values-and-principles-a-poem">
<h1>Values and Principles – A Poem</h1>
<p style="text-align: center;text-indent:1em">My principles, I will not forsake,</p>
<p style="text-align: center;">I will keep the promises I make.</p>
<p style="text-align: center;">If my values, I would have to defend,</p>
<p style="text-align: center;">Upon my principles, I would always depend.</p>
<p style="text-align: center;">On honesty, I will always rely,</p>
<p style="text-align: center;">And lies, I would forever defy.</p>
<p style="text-align: center;">I would live a life above reproach,</p>
<p style="text-align: center;">Upon another’s repute, I would not encroach.</p>
<p style="text-align: center;">Our values are not gauged by our worldly gain,</p>
<p style="text-align: center;">They are built upon principles that have not a stain.</p>
<p style="text-align: center;">If such an honor, I can attain,</p>
<p style="text-align: center;">I shall not have lived my life in vain.</p>
<p style="text-align: center;">These few lines to you I sing,</p>
<p style="text-align: center;">They tell of the life, I strive to bring.</p>
<p style="text-align: center;">To live the virtuous, honorable life,</p>
<p style="text-align: center;">Is for all, the greatest thing!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?339c7c7a